import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20modern%20Asian%20cityscape%20at%20sunset%20with%20warm%20golden%20light%2C%20traditional%20temple%20rooftops%20blending%20with%20contemporary%20architecture%2C%20river%20winding%20through%20the%20city%2C%20misty%20mountains%20in%20the%20distance%2C%20vibrant%20cultural%20atmosphere%2C%20cinematic%20color%20grading%2C%20artistic%20composition&width=1600&height=900&seq=hero-asia-zone-2026&orientation=landscape"
          alt="亚洲一区 - 探索亚洲优质内容"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-line text-accent-400 text-sm"></i>
            <span className="text-background-50/90 text-sm font-medium">亚洲精选内容平台</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            精选内容汇聚
            <br />
            <span className="text-accent-300">尽在亚洲一区</span>
          </h1>
          <p className="text-background-200/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            亚洲一区是您探索亚洲优质内容的首选平台，汇聚独家精选资源，覆盖多元文化、娱乐、资讯与生活方式，为用户提供沉浸式亚洲体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/wenhua-chuancheng"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              探索精选内容
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}